import React, { Component } from "react";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import { connect } from "react-redux";

// core components
import GridItem from "components/Grid/GridItem.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
// import Card from "components/Card/Card.jsx";
// import CardBody from "components/Card/CardBody.jsx";
// import CardHeader from "components/Card/CardHeader.jsx";
import withMobileDialog from "@material-ui/core/withMobileDialog";
import dashboardStyle from "assets/jss/material-dashboard-react/views/dashboardStyle.jsx";
import { store } from "../../_store";
// import {apiActions} from "../../_actions/api.actions";
import { alertActions, commonActions } from "../../_actions";
// import { startAction, stopAction } from "../../_actions/progress.actions";
import { EmptyRecord } from "../../utils/PageUtility";
import { commonService } from "../../_services";
import { appConstants } from "../../_constants";
import CircularProgress from '../../utils/CircularProgress';
import ReconciliationPanel from './ReconciliationPanel'
import ReconciliationTable from './ReconciliationTable'
import MyReconciliationTable from './MyReconciliationTable'
import Tabs from "components/CustomTabs/CustomTabs.jsx";

// material icons
import ReconciliationIcon from "@material-ui/icons/RestorePage";
import { appHelpers } from "../../_helpers";

const statusTypes = [
    {name: "Select Status", value: "Placeholder"},
    { name: "Pending", value: 0 },
    { name: "Approved", value: 1 },
    { name: "Declined", value: 2 }
];

const reconciliationTypes = [
    {name: "Select Reconciliation Type", value: "Placeholder"},
    { name: "Debit", value: 0 },
    { name: "Credit", value: 1 }
];

const today = new Date();
let aMonthAgo = new Date();
aMonthAgo.setDate(today.getDate() - 30);


class Reconciliation extends Component {
    constructor(props) {
        super(props);
        this.state = {
            open: false,
            airlines: [],
            users: [],
            name: '',
            airlineName: '',
            airports: [],
            airportName: "",
            airportCode: "-1",
            newAirportCode: "-1",
            reconciliationData: [],
            myReconciliationData: [],
            AirlineId: '-1',
            Type: '',
            Status: 0,
            startDate: aMonthAgo,
            endDate: today,
            reconciliationType: '',
            status: '',
            isProgressActive: true,
            currentPage: 1,
            pageSize: 10,
            totalPaymentCount: 0,
            requestingReconciliation: true,
            isOpen: false,
            isEditModalOpen: false,
            error: false,
            formError: '',
            newAmount: '',
            Rate: '',
            newAirlineId: '-1',
            narration: '',
            newType: '',
            newCurrency: "",
            pendingReconId: '',
            reconId: '',
            isCommentModalOpen: false,
            comment: '',
            processName: '',
            airlineError: false,
            airportError: false,
            tokenError: false,
            narrationError: false,
            typeError: false,
            currentTab: 0,
            currencyOptions: [],
            currency: "",
            newRate:""
        };
    }


    componentDidMount() {
        const { regionalAirports, regionalAirlines, user, currencies} = store.getState();
        let { pageSize, startDate, endDate, Status } = this.state;

        const { dispatch } = this.props;
        this.fetchAirlines()
        this.fetchUsers()
        //  this.loadReconciliationData()
        this.fetchTokenRate({ serviceType: 1 }, "currentTokenRegionalCharge");
        this.fetchTokenRate({ serviceType: 2 }, "currentTokenInternationalCharge");
        if (regionalAirports) {
            this.setState({ regionalAirports})
        } else {
            dispatch(commonActions.getAllAirportsRegional());
        }

        if (regionalAirlines) {
            this.setState({ airlines: regionalAirlines });
        } else {
            dispatch(commonActions.getAllAirlinesRegional());
        }

        if (currencies) {
            this.setState({ currencyOptions: currencies });
        } else {
            dispatch(commonActions.getAllCurrencies());
        }

        if (user.Location) {
            let userObj = {...user};
            let userLocation = {value: userObj.AirportCode, label: userObj.Location};
            this.setState({airportCode: userLocation, newAirportCode: userLocation});
            let payload = {
                StartDate: appHelpers.formatDateSpecific(startDate, "YYYY-MM-DD"),
                EndDate: appHelpers.formatDateSpecific(endDate, "YYYY-MM-DD"),
                From: 1,
                Size: pageSize,
                UserId: user.userId,
                Status: Status,
                AirportCode: user.AirportCode
            };
            this.loadReconciliationData(payload);
        }else if (user.AppRole === appConstants.ROLES.AIRPORT_MANAGER) {
            let userObj = {...user};
            let userLocation = {value: userObj.AirportCode, label: userObj.Location};
            this.setState({ airportCode: userLocation, newAirportCode: userLocation });
            let payload = {
                StartDate: appHelpers.formatDateSpecific(startDate, "YYYY-MM-DD"),
                EndDate: appHelpers.formatDateSpecific(endDate, "YYYY-MM-DD"),
                From: 1,
                Size: pageSize,
                UserId: user.userId,
                Status: Status,
                AirportCode: user.AirportCode
            };
            this.loadReconciliationData(payload);
        } else {
            this.loadReconciliationData()
        }
    }

    componentWillReceiveProps = function (nextProps) {
        const { regionalAirlines, regionalAirports, users, currencies } = nextProps;
        const { dispatch } = this.props;

        if (regionalAirlines) {
                let modifiedAirline = [...regionalAirlines];
                let allAirlines = {Airline: "All Airlines", AirlineId: "-1"};
                modifiedAirline.unshift(allAirlines);
                this.setState({ airlines: modifiedAirline });
        }
        if (users) {
            this.setState({ users: users.ResultList });
        }
        // if (currencies !== this.props.currencies) {
        //     this.setState({ currencyOptions: currencies });
        // }

        if (currencies) {
            let modifiedCurrency = [...currencies];
            modifiedCurrency.unshift({Name: "All Currency", Code: "-1"});
            this.setState({ currencyOptions: modifiedCurrency })
        } else {
            dispatch(commonActions.getAllCurrencies());
        }

        if (regionalAirports) {
            let modifiedAirport = [...regionalAirports];
            modifiedAirport.unshift({Name: "All Airports", Code: "-1"});
            this.setState({ airports: modifiedAirport })
        } else {
            dispatch(commonActions.getAllAirportsRegional());
        }
    };

    loadReconciliationData = (payload) => {
        this.searchReconciliation(1, payload)
        this.searchMyReconciliation(1, payload)
    }

    handleDateChange = (date, target) => {
        this.setState({ [target]: date });
    };

    // fetch users
    fetchUsers = () => {
        const { dispatch, users } = this.props
        if (users) {
            this.setState({ users: users.ResultList })
        }
        else {
            dispatch(commonActions.getAllUsers());
        }
    }

    // fetch airlines
    fetchAirlines = () => {

        let { airlines } = store.getState();
        const { dispatch } = this.props;
        dispatch(alertActions.startRequest())

        if (airlines) {
            dispatch(alertActions.stopRequest())
            this.setState({ airlineData: airlines, dataCount: airlines.Count })
        } else {
            dispatch(commonActions.getAllAirlines())
            setTimeout(() => {
                dispatch(alertActions.stopRequest())
            }, 3000)
        }
    }

    // method: display name of airlineId
    filterAirlines = (airlineId) => {
        const { airlines } = this.state;
        let airlineName = airlines.find(u => u.AirlineId === airlineId);
        if (airlineName) {
            return `${airlineName.Airline}`
        } else {
            return 'Unknown Airline'
        }
    }


    //Displays Airport Name
    filterAirport = (airportCode) => {
        const { airports } = this.state;
        let result = airports.find(item => item.Code === airportCode);
        let name = result ? result.Name : "Unknown Airport"
        return name
    }

    // method: display name of userId
    filterUsers = (userId) => {
        const { users } = this.state;
        if (users) {
            if (userId === null) {
                return ""
            } else {
                let userName = users.find(u => u.Id === userId);
                if (userName) {
                    return `${userName.FirstName} ${userName.LastName}`
                } else {
                    return 'Unknown User'
                }
            }
        }
    }

    // display name of statusId
    filterStatus = (statusId) => {
        let status = statusTypes.find(item => item.value === statusId)
        if (status) {
            return `${status.name}`
        } else {
            return 'Unknown Status'
        }
    }

    // approve a reconcilation
    approveReconciliation = () => {

        const { user, dispatch } = this.props
        let userId = user.userId
        const payload = {
            PendingReconciliationId: this.state.reconId,
            ProcessedBy: userId,
            Status: 1,
            Comment: this.state.comment
        }
console.log(payload, "approvePayload");
        dispatch(alertActions.startRequest());

        commonService.processReconciliationRegional(payload)
            .then((res) => {
                dispatch(alertActions.stopRequest());
                if (res.status === appConstants.SUCCESS_RESPONSE) {
                    dispatch(alertActions.notify(res.response));
                    this.closeCommentModal()
                    this.searchReconciliation()
                }
                else if (res.status === appConstants.ERROR_RESPONSE) {
                    dispatch(alertActions.error(res.response));
                }
            })
    }

    // decline a reconciliation
    declineReconciliation = () => {

        const { user, dispatch } = this.props
        let userId = user.userId
        const payload = {
            PendingReconciliationId: this.state.reconId,
            ProcessedBy: userId,
            Status: 2,
            Comment: this.state.comment
        }

        dispatch(alertActions.startRequest());

        commonService.processReconciliationRegional(payload)
            .then((res) => {
                dispatch(alertActions.stopRequest());
                if (res.status === appConstants.SUCCESS_RESPONSE) {
                    dispatch(alertActions.notify(res.response));
                    this.closeCommentModal()
                    this.searchReconciliation()

                }
                else if (res.status === appConstants.ERROR_RESPONSE) {
                    dispatch(alertActions.error(res.response));
                }

            })
    };

    handleReactSelectChange = (value, name) => {
        this.setState({[name.name]: value})
        if (value.value === undefined || value.value === "-1" || value.value === "All Flights"){
            this.setState({[name.name]: "-1"} )
        }
    };

    handleSelectChange = prop => event => {
        this.setState({ [prop]: event.target.value });
    };

    handleChange = (event) => {
        this.setState({ [event.target.name]: event.target.value })
    }

    // fetch token rate
    // fetchTokenRate = (payload, attibute) => {
    //     const { dispatch } = this.props

    //     commonService.getCurrentPscRegional(payload)
    //     .then((getPsc) => {
    //         if (getPsc.status === appConstants.SUCCESS_RESPONSE) {
    //             this.setState({ [attibute]: getPsc.response.PscCharge });
    //         } else if (getPsc.status === appConstants.ERROR_RESPONSE) {
    //             dispatch(alertActions.error(getPsc.response));
    //             this.setState({ pageRequesting: false });
    //         }
    //     })
    //     .catch((err) => {
    //         // dispatch(alertActions.error(err.response));
    //     });
    // dispatch(alertActions.clear());
    // }

    fetchTokenRate = () => {
        const { dispatch } = this.props

        commonService.getCurrentPsc()
            .then((res) => {
                let response = res.response;
                if (res.status === appConstants.SUCCESS_RESPONSE) {
                    this.setState({
                        Rate: response.PscCharge
                    })
                }
                else if (res.status === appConstants.ERROR_RESPONSE) {
                    dispatch(alertActions.error(res.response));
                }
            })
    }

    //search reconciliation with parameters
    searchReconciliation = (pageNumber = 1, payload) => {
        let { AirlineId, airportCode, pageSize, startDate, endDate, Status, Type, currency } = this.state;
        const { dispatch, user } = this.props;
        startDate = appHelpers.formatDateSpecific(startDate, "YYYY-MM-DD");
        endDate = appHelpers.formatDateSpecific(endDate, "YYYY-MM-DD");
        let CurrencyCode = currency === "-1" ? "" : currency.value;

        if (!payload) {
            payload = {
                StartDate: startDate,
                EndDate: endDate,
                From: pageNumber,
                Size: pageSize,
                UserId: user.userId,
                CurrencyCode,
            };

            if (AirlineId !== "-1") {
                payload.AirlineId = AirlineId.value
            }
            if (airportCode !== "-1") {
                payload.AirportCode = airportCode.value
            }
            if (Status !== "") {
                payload.Status = Status.value
            }
            if (Type !== "") {
                payload.ReconciliationType = Type.value
            }
        }

        dispatch(alertActions.startRequest());
        commonService.getOtherReconciliationRegional(payload)
            .then((res) => {
                dispatch(alertActions.stopRequest());
                let response = res.response;
                if (res.status === appConstants.SUCCESS_RESPONSE) {
                    this.setState({
                        currentPage: pageNumber,
                        totalCount: response.TotalCount,
                        reconciliationData: response.PendingReconciliation,
                        requestingReconciliation: false
                    })
                }
                else if (res.status === appConstants.ERROR_RESPONSE) {
                    dispatch(alertActions.error(res.response));
                    this.setState({ requestingReconciliation: false });
                }
            })
    };

    //search user-created reconciliations with parameters
    searchMyReconciliation = (pageNumber = 1, payload) => {
        let { AirlineId, airportCode, pageSize, startDate, endDate, Type, Status, currency } = this.state;
        const { dispatch, user } = this.props;

        startDate = appHelpers.formatDateSpecific(startDate, "YYYY-MM-DD");
        endDate = appHelpers.formatDateSpecific(endDate, "YYYY-MM-DD");
        let CurrencyCode = currency === "-1" ? "" : currency.value;

        if (!payload) {
            payload = {
                StartDate: startDate,
                EndDate: endDate,
                From: pageNumber,
                Size: pageSize,
                UserId: user.userId,
                CurrencyCode
            };

            if (AirlineId !== "-1") {
                payload.AirlineId = AirlineId.value
            }
            if (airportCode !== "-1") {
                payload.AirportCode = airportCode.value
            }
            if (Type !== "") {
                payload.ReconciliationType = Type.value
            }
            if (Status !== "") {
                payload.Status = Status.value
            }
        }


        dispatch(alertActions.startRequest());
        commonService.getMyReconciliationRegional(payload)
            .then((res) => {
                dispatch(alertActions.stopRequest());
                let response = res.response;
                if (res.status === appConstants.SUCCESS_RESPONSE) {
                    this.setState({
                        myCurrentPage: pageNumber,
                        myTotalCount: response.TotalCount,
                        myReconciliationData: response.PendingReconciliation,
                        requestingReconciliation: false
                    })
                }
                else if (res.status === appConstants.ERROR_RESPONSE) {
                    dispatch(alertActions.error(res.response));
                    this.setState({ requestingReconciliation: false });
                }
            })
    };

    //open add reconciliation modal
    handleOpenModal = () => {
        this.setState({ isOpen: true })
    };

    // close add reconciliation modal
    handleCloseModal = () => {
        this.setState({
            isOpen: false,
            airlineError: false,
            tokenError: false,
            narrationError: false,
            typeError: false
        });
        this.resetForm()
    };

    //open edit reconciliation Modal
    openEditModal = (item) => {
        this.setState({ isEditModalOpen: true })
        this.setState({
            newAirportCode: item.AirportCode,
            newAirlineId: item.AirlineId,
            newAmount: item.Amount,
            narration: item.Narration,
            newType: ((item.Iscredit) ? 1 : 0),
            pendingReconId: item.Id,
            newCurrency: item.CurrencyCode,
            newRate: item.Rate,
        })
    };

    // close edit reconciliation modal
    closeEditModal = () => {
        this.setState({
            isEditModalOpen: false, airlineError: false,
            tokenError: false,
            narrationError: false,
            typeError: false
        });
    };

    // open comment modal
    openCommentModal = (reconId, action) => {
        this.setState({
            reconId,
            isCommentModalOpen: true,
            processName: action
        })
    }

    // close comment modal
    closeCommentModal = () => {
        this.setState({
            isCommentModalOpen: false,
            reconId: "",
            comment: ""
        })
    }


    // update reconciliation
    handleUpdate = (reconId) => {

        const { newAmount,newRate, newCurrency, narration, newAirlineId, newType, newAirportCode, } = this.state
        const { user, dispatch } = this.props

        if (!newAirportCode || newAirportCode === "Placeholder") {
            this.setState({ airportError: true })
        } else {
            this.setState({ airportError: false })
        }

        if (newAirlineId === "" || newAirlineId === "Placeholder") {
            this.setState({ airlineError: true })
        } else {
            this.setState({ airlineError: false })
        }

        if (newAmount === "") {
            this.setState({ tokenError: true })
        } else {
            this.setState({ tokenError: false })
        }
        if (newCurrency === "") {
            this.setState({ tokenError: true })
        } else {
            this.setState({ tokenError: false })
        }
        if (newRate === "") {
            this.setState({ tokenError: true })
        } else {
            this.setState({ tokenError: false })
        }

        if (narration === "") {
            this.setState({ narrationError: true })
        } else {
            this.setState({ narrationError: false })
        }

        if (newType === "") {
            this.setState({ typeError: true })
        } else {
            this.setState({ typeError: false })
        }

        if (!newAirportCode || newAirlineId === "" || newAirlineId === "Placeholder" || newAmount === "" || narration === "" || newType === "" || newCurrency === "") {
            return
        }
        // let CurrencyCode = newCurrency === "-1" ? "" : newCurrency.value;

        const payload = {
            PendingReconciliationId: reconId,
            AirlineId: newAirlineId,
            AirportCode: newAirportCode,
            Amount: newAmount,
            Rate: newRate,
            Narration: narration,
            ReconciliationType: newType,
            CreatedBy: user.userId,
            CurrencyCode: newCurrency
        }
        dispatch(alertActions.startRequest());

        commonService.updateReconciliationRegional(payload)
            .then((res) => {
                dispatch(alertActions.stopRequest());
                if (res.status === appConstants.SUCCESS_RESPONSE) {

                    dispatch(alertActions.notify(res.response));
                    this.closeEditModal()
                    this.searchMyReconciliation()
                }
                else if (res.status === appConstants.ERROR_RESPONSE) {
                    dispatch(alertActions.error(res.response));
                    this.setState({
                        formError: res.response,
                        error: true,
                        requestingReconciliation: false
                    });
                }
            })
    }

    // add new reconciliation
    handleSubmit = () => {

        const { newAmount, Rate, narration, newAirlineId,
            newType, newAirportCode, currency
        } = this.state
        const { user, dispatch } = this.props;

        if (!newAirportCode || newAirportCode === "-1") {
            this.setState({ airportError: true })
        } else {
            this.setState({ airportError: false })
        }

        if (newAirlineId === "" || newAirlineId === "-1") {
            this.setState({ airlineError: true })
        } else {
            this.setState({ airlineError: false })
        }

        if (newAmount === "") {
            this.setState({ tokenError: true })
        } else {
            this.setState({ tokenError: false })
        }

        if (narration === "") {
            this.setState({ narrationError: true })
        } else {
            this.setState({ narrationError: false })
        }

        if (newType === "") {
            this.setState({ typeError: true })
        } else {
            this.setState({ typeError: false })
        }

        if (!newAirportCode || newAirlineId === "" || newAirlineId === "-1" || newAmount === "" || narration === "" || newType === "") {
            return
        }
        let CurrencyCode = currency === "-1" ? "" : currency.value;

        const payload = {
            AirportCode: newAirportCode.value,
            AirlineId: newAirlineId.value,
            Amount: newAmount,
            Rate: Rate,
            Narration: narration,
            ReconciliationType: newType.value,
            CreatedBy: user.userId,
            CurrencyCode
        }
        dispatch(alertActions.startRequest());
        console.log(payload, "addPayload");

        commonService.addReconciliationRegional(payload)
            .then((res) => {
                dispatch(alertActions.stopRequest());
                if (res.status === appConstants.SUCCESS_RESPONSE) {

                    dispatch(alertActions.notify(res.response));
                    this.handleCloseModal()
                    this.searchMyReconciliation()
                    this.resetForm()
                }
                else if (res.status === appConstants.ERROR_RESPONSE) {
                    dispatch(alertActions.error(res.response));
                    this.setState({
                        formError: res.response,
                        error: true,
                        requestingReconciliation: false
                    });
                }
            })
    };

    resetForm = () => {
        const {newAirportCode} = this.state;
        const { user } = this.props;
        const newAirportCode_ = (user.AppRole === appConstants.ROLES.AIRPORT_MANAGER) || (user.Location) ? newAirportCode: "-1";
        this.setState({
            newAmount: "", narration: "", newType: "", newCurrency: "", newRate: "",
            newAirportCode: newAirportCode_, newAirlineId: "-1"
        })
    };
    
    selectedTab = (key) => {
        this.setState({currentTab: key})
    };

    render() {
        const { airlines, reconciliationData, AirlineId, airlineName,
            startDate, endDate, currentPage, pageSize, totalCount,
            requestingReconciliation, Type, Status, isOpen, isEditModalOpen,
            newAmount, Rate, newAirlineId, narration, newType, newCurrency,
            pendingReconId, isCommentModalOpen, comment, processName,
            formError, error, myReconciliationData, myCurrentPage, newRate,
            airlineError, narrationError, tokenError, typeError, airports,
             airportCode, airportName, newAirportCode, currencyOptions, currency,
            myTotalCount, airportError } = this.state;

        let { requesting, user } = this.props;

        if (requestingReconciliation)
            return (
                <CircularProgress />
            );
        return (
            <div>

                <ReconciliationPanel
                    user={this.props.user}
                    formError={formError}
                    airlineError={airlineError}
                    airportError={airportError}
                    narrationError={narrationError}
                    tokenError={tokenError}
                    typeError={typeError}
                    error={error}
                    airline={airlineName}
                    AirlineId={AirlineId.value}
                    airports={airports}
                    airportName={airportName}
                    airportCode={(this.props.user.AppRole === appConstants.ROLES.AIRPORT_MANAGER) || (user.Location) ? airportCode : airportCode.value}
                    newAirportCode={(this.props.user.AppRole === appConstants.ROLES.AIRPORT_MANAGER) || (user.Location) ? newAirportCode : newAirportCode.value}
                    Type={Type.value}
                    Status={Status.value}
                    selectChange={this.handleReactSelectChange}
                    selectAirlineChange={this.handleSelectChange}
                    selectTypeChange={this.handleSelectChange}
                    selectStatusChange={this.handleSelectChange}
                    data={airlines}
                    onSearch={this.loadReconciliationData}
                    startDate={startDate}
                    endDate={endDate}
                    startLabel='Start Date'
                    endLabel='End Date'
                    handleDateChange={this.handleDateChange}
                    handleEndDateChange={this.handleDateChange}
                    isOpen={isOpen}
                    handleOpenModal={this.handleOpenModal}
                    handleSubmit={this.handleSubmit}
                    handleClose={this.handleCloseModal}
                    handleChange={this.handleChange}
                    newAmount={newAmount}
                    Rate={Rate}
                    narration={narration}
                    newAirlineId={newAirlineId.value}
                    newType={newType.value}
                    reconciliationTypes={reconciliationTypes}
                    statusTypes={statusTypes}
                    requesting={requesting}
                    currencyOptions={currencyOptions}
                    currency={currency.value}
                    reactSelectChange={this.handleReactSelectChange}
                />

                <GridContainer>
                    <Tabs
                        headerColor="regional"
                        tabs={[
                            {
                                tabName: "My Reconciliations",
                                tabIcon: ReconciliationIcon,
                                clickEvent: (key) => this.selectedTab(key),
                                tabContent: (
                                    <GridItem xs={12} sm={12} md={12}>
                                        {
                                            !requestingReconciliation && myTotalCount !== 0
                                            &&
                                            <MyReconciliationTable
                                                formError={formError}
                                                error={error}
                                                airlineError={airlineError}
                                                airportError={airportError}
                                                narrationError={narrationError}
                                                tokenError={tokenError}
                                                typeError={typeError}
                                                reconciliationData={myReconciliationData}
                                                currentPage={myCurrentPage}
                                                pageSize={pageSize}
                                                fetchReconciliation={this.searchMyReconciliation}
                                                totalCount={myTotalCount}
                                                filterAirlines={this.filterAirlines}
                                                filterAirport={this.filterAirport}
                                                filterUsers={this.filterUsers}
                                                filterStatus={this.filterStatus}
                                                // approveReconciliation={this.approveReconciliation}
                                                // declineReconciliation={this.declineReconciliation}
                                                editReconciliation={this.editReconciliation}
                                                openEditModal={this.openEditModal}
                                                closeEditModal={this.closeEditModal}
                                                isEditModalOpen={isEditModalOpen}
                                                handleChange={this.handleChange}
                                                handleUpdate={this.handleUpdate}
                                                newAmount={newAmount}
                                                Rate={Rate}
                                                newRate={newRate}
                                                narration={narration}
                                                newAirlineId={newAirlineId}
                                                newType={newType}
                                                newCurrency={newCurrency}
                                                currencyOptions={currencyOptions}
                                                airports={airports}
                                                airportCode={airportCode}
                                                newAirportCode={newAirportCode}
                                                pendingReconId={pendingReconId}
                                                airlines={airlines}
                                                selectCurrencyChange={this.handleSelectChange}
                                                selectAirlineChange={this.handleSelectChange}
                                                selectTypeChange={this.handleSelectChange}
                                                reconciliationTypes={reconciliationTypes}
                                                disabled={requesting}
                                            // isCommentModalOpen={isCommentModalOpen}
                                            // openCommentModal={this.openCommentModal}
                                            // closeCommentModal={this.closeCommentModal}
                                            // comment={comment}
                                            // processName={processName}
                                            />}

                                        {
                                            !requestingReconciliation && myTotalCount === 0
                                            && <EmptyRecord message={'No reconciliation record'} />
                                        }
                                    </GridItem>

                                )
                            },
                            {
                                tabName: "All Reconciliations",
                                tabIcon: ReconciliationIcon,
                                clickEvent: (key) => this.selectedTab(key),
                                tabContent: (
                                    <GridItem xs={12} sm={12} md={12}>
                                        {
                                            !requestingReconciliation && totalCount !== 0
                                            &&
                                            <ReconciliationTable
                                                formError={formError}
                                                error={error}
                                                reconciliationData={reconciliationData}
                                                currentPage={currentPage}
                                                pageSize={pageSize}
                                                fetchReconciliation={this.searchReconciliation}
                                                totalCount={totalCount}
                                                filterAirlines={this.filterAirlines}
                                                filterUsers={this.filterUsers}
                                                filterStatus={this.filterStatus}
                                                approveReconciliation={this.approveReconciliation}
                                                declineReconciliation={this.declineReconciliation}
                                                // editReconciliation={this.editReconciliation}
                                                // openEditModal={this.openEditModal}
                                                // closeEditModal={this.closeEditModal}
                                                // isEditModalOpen={isEditModalOpen}
                                                handleChange={this.handleChange}
                                                handleUpdate={this.handleUpdate}
                                                newAmount={newAmount}
                                                Rate={Rate}
                                                narration={narration}
                                                newAirlineId={newAirlineId}
                                                newType={newType}
                                                newCurrency={newCurrency}
                                                pendingReconId={pendingReconId}
                                                airlines={airlines}
                                                aiports={airports}
                                                airportCode={airportCode}
                                                newAirportCode={newAirportCode}
                                                selectAirlineChange={this.handleSelectChange}
                                                // selectCurrencyChange={this.handleSelectChange}
                                                selectTypeChange={this.handleSelectChange}
                                                reconciliationTypes={reconciliationTypes}
                                                isCommentModalOpen={isCommentModalOpen}
                                                openCommentModal={this.openCommentModal}
                                                closeCommentModal={this.closeCommentModal}
                                                comment={comment}
                                                processName={processName}
                                                filterAirport={this.filterAirport}
                                                disabled={requesting}
                                            />}

                                        {
                                            !requestingReconciliation && totalCount === 0
                                            && <EmptyRecord message={'No reconciliation record'} />
                                        }
                                    </GridItem>
                                )
                            }
                        ]}
                    />
                </GridContainer>

            </div>
        );
    }
}

function mapStateToProps(state, ownProps) {
    const { modal, alert, regionalAirports, regionalAirlines, reconciliation, user,
        users, requesting, currencies } = state;
    return {
        modal,
        alert,
        regionalAirlines,
        reconciliation,
        user,
        users,
        regionalAirports,
        requesting,
        currencies
    };
}
export default connect(mapStateToProps)(withMobileDialog()(withStyles(dashboardStyle)(Reconciliation)));



// WEBPACK FOOTER //
// ./src/Regional-Views/Reconciliation/Index.jsx